import { requestHost } from 'fetch/interceptors/requestHost';
import { createClient } from 'react-fetching-library';
import { Store } from 'redux';
import { AppState } from 'store/store';
import { getAppConfig } from 'utils/config/appConfig';

// Global interceptor to ensure cookies are sent with all requests
const credentialsIncludeInterceptor = (action) => ({
  ...action,
  credentials: 'include',
});

export const getFetchClient = (store?: Store<AppState>) => {
  const apiUrl = getAppConfig('OSIN20_API_URL');

  return createClient({
    requestInterceptors: [
      credentialsIncludeInterceptor, // Ensures HTTP-only cookies are sent with all requests
      requestHost(apiUrl),
    ],
    responseInterceptors: [],
  });
};
